import React from 'react'
import {Input } from 'reactstrap';

export const GlobalFilter = ({filter,setFilter}) => {
    return (
        <div className='text-right mb-3'>
            Buscar en la tabla: {''}
            <input className="buscadorTablaHistorial"value ={filter || ''}  onChange={(e) => setFilter(e.target.value)}></input>
        </div>
    )
}
